// routes
import React from 'react';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded';
import StyleIcon from '@mui/icons-material/Style';
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';

// color: '#1F4466'
const getIcon = (name: string) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  pathways: getIcon('ic_pathways'),
  explore_2: getIcon('ic_explore_2'),
  explore_3: getIcon('ic_explore_3'),
  activity: getIcon('ic_analytics')
};

const sidebarConfig = [
  {
    subheader: 'menu.my_learning',
    items: [
      {
        title: 'menu.overview',
        path: PATH_DASHBOARD.overview.root,
        icon: <GridViewOutlinedIcon sx={{ width: '100%', height: '100%' }} />
      },
      {
        title: 'menu.up_next',
        path: PATH_DASHBOARD.upNext.root,
        icon: <ChecklistRoundedIcon sx={{ width: '100%', height: '100%' }} />
      },
      {
        title: 'menu.flashcard_practice',
        path: PATH_DASHBOARD.flashcards.root,
        icon: <StyleIcon sx={{ width: '100%', height: '100%' }} />
      },
      {
        title: 'menu.my_pathways',
        path: PATH_DASHBOARD.pathways.view,
        icon: ICONS.pathways
      }
    ]
  },
  {
    subheader: 'menu.peer_tutoring',
    items: [
      {
        title: 'menu.circles',
        path: PATH_DASHBOARD.circle.root,
        icon: ICONS.explore_2,
        exact: true
      },
      {
        title: 'menu.circle_activity',
        path: PATH_DASHBOARD.circle.activity,
        icon: ICONS.activity
      }
    ]
  }
];

export default sidebarConfig;
